import Splide from '@splidejs/splide';

(() => {
    const blocks = document.querySelectorAll('[data-anchor-thumbnails-slider]');

    const bigOptions = {
        type: 'fade',
        rewind: true,
        // The arrows are hidden below md, so a swipe past the last slide goes back to the first.
        rewindByDrag: true,
        pagination: false,
        lazyLoad: 'nearby',
        preloadPages: 0,
    };
    const thumbOptions = {
        rewind: true,
        perPage: 'auto',
        isNavigation: true,
        gap: 1,
        pagination: false,
        arrows: false,
        breakpoints: {
            768: {
                gap: 0,
            },
        },
    };

    for (let block of blocks) {
        const main = new Splide(block.querySelector('.splide-thumbnails-slider'), bigOptions);
        const thumbnails = new Splide(block.querySelector('.splide-thumbnails-slider-thumbs'), thumbOptions);

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();
    }
})();
